import React from 'react';
import { STATUS_META } from './constants';

// The one workflow status badge (docs/workflow-ui.md §2). Replaces the old
// StatusBadge (WorkflowEng), RequestStatusBadge (WorkflowQca) and the raw
// StatusChip (SourceRequestModal).
//   size="xs"   — default badge (lists, detail cards)
//   size="chip" — compact chip (dense modals like SourceRequestModal)
// whitespace-nowrap: the labels are two words ("Pending review", "Changes
// required") and a narrow list column would otherwise break one across two
// lines and stretch the row.
//   meta        — a flow's own vocabulary (CPD_STATUS_META); default STATUS_META
const WorkflowStatusBadge = ({ status, size = 'xs', meta: vocab = STATUS_META }) => {
  const meta = vocab[status] || STATUS_META[status] || { label: status, cls: 'bg-slate-100 text-slate-600' };
  const sizeCls = size === 'chip' ? 'px-1.5 py-0.5 text-[10px]' : 'px-2 py-0.5 text-xs';
  return (
    <span className={`inline-flex items-center whitespace-nowrap rounded font-medium ${sizeCls} ${meta.cls}`}>
      {meta.label}
    </span>
  );
};

export default WorkflowStatusBadge;
